export default "__VITE_ASSET__RTSKu9px__"